module.exports = __webpack_public_path__ + "static/media/default-profile.acbfb35f.svg";